import(/* webpackMode: "eager" */ "/vercel/path0/app/qr-generator/page.tsx");
